import React from "react";
import PropTypes from "prop-types";

const BuildingIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="43"
    height="49"
    viewBox="0 0 43 49"
  >
    <defs>
      <path id="a" d="M.04 47.975h40.844V.047H.04z" />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(1.026)">
      <path
        fill="#FFF"
        d="M36.403 35.645c2.69 1.283 4.294 2.899 4.294 4.654 0 4.173-9.06 7.556-20.235 7.556-11.175 0-20.234-3.383-20.234-7.556 0-1.456 1.104-2.816 3.016-3.97"
      />
      <path
        stroke="#000"
        strokeWidth=".616"
        d="M36.403 35.645c2.69 1.283 4.294 2.899 4.294 4.654 0 4.173-9.06 7.556-20.235 7.556-11.175 0-20.234-3.383-20.234-7.556 0-1.456 1.104-2.816 3.016-3.97"
      />
      <path
        stroke="#000"
        strokeWidth=".616"
        d="M37.186 37.74l-.414-1.056-.413-1.057 1.105-.104 1.105-.103"
      />
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path
        fill="#BEF6FF"
        d="M6.73 26.881l-.054 13.712 6.13.018.02-7.62 2.581.008-.021 7.62 2.097.006.054-13.712z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M8.854 35.621l.008-2.606 2.54.007-.008 2.607z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M8.674 32.821l-.008 2.993 2.916.008.008-2.992-2.916-.009zm.375.387l2.164.007-.006 2.22-2.164-.006.006-2.22z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M8.742 31.124l.007-2.606 2.54.008-.007 2.606z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M8.562 28.325l-.009 2.992 2.916.008.008-2.992-2.915-.008zm.374.387l2.164.006-.006 2.22-2.164-.006.006-2.22z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M12.838 31.136l.008-2.606 2.54.008-.008 2.606z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M12.658 28.337l-.008 2.992 2.916.008.008-2.992-2.916-.008zm.375.387l2.164.006-.006 2.22-2.164-.006.006-2.22z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M15.605 40.62l-2.78-.009.02-7.62 2.781.009z"
        mask="url(#b)"
      />
      <path
        stroke="#000"
        strokeWidth=".5"
        d="M15.605 40.62l-2.78-.009.02-7.62 2.781.009zM15.193 24.226l-2.386 1.937M13.125 24.22l2.375 1.95M15.573 26.788l-.303-2.59M12.738 26.78l.318-2.588"
        mask="url(#b)"
      />
      <path
        fill="#004F8A"
        d="M14.166 21.563l-1.884-.006.944-.598.944-.597.94.603.94.603z"
        mask="url(#b)"
      />
      <path
        fill="#004F8A"
        d="M15.326 24.213l-2.334-.007a.357.357 0 0 1-.35-.361l.007-2.484 3.036.01-.007 2.482c0 .199-.16.36-.352.36"
        mask="url(#b)"
      />
      <path
        fill="#BEF6FF"
        d="M19.62 1.449l-.075 39.037 8.31.024.029-10.33 3.498.01-.029 10.33 2.843.009.074-39.037z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M22.297 21.493l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M22.12 17.63l-.012 4.056 3.953.011.011-4.056-3.953-.011zm.374.387l3.201.009-.009 3.284-3.2-.01.008-3.283z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M22.262 33.814l.01-3.67 3.578.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M22.085 29.95l-.011 4.056 3.953.011.011-4.056-3.953-.011zm.375.387l3.2.01-.008 3.284-3.201-.01.009-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M22.28 27.718l.01-3.67 3.576.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M22.102 23.854l-.011 4.056 3.953.012.011-4.056-3.953-.012zm.375.387l3.201.01-.01 3.284-3.2-.01.009-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M27.85 21.51l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M27.673 17.646l-.011 4.056 3.953.011.01-4.056-3.952-.011zm.375.387l3.2.01-.008 3.284-3.201-.01.009-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M27.833 27.734l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M27.656 23.87l-.012 4.056 3.953.012.012-4.056-3.953-.012zm.375.387l3.2.01-.009 3.284-3.2-.01.009-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M31.48 40.52l-3.769-.01.03-10.33 3.768.01z"
        mask="url(#b)"
      />
      <path
        stroke="#000"
        strokeWidth=".5"
        d="M31.48 40.52l-3.769-.01.03-10.33 3.768.01z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M22.297 15.192l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M22.12 11.328l-.012 4.056 3.953.012.011-4.056-3.953-.012zm.374.387l3.201.01-.009 3.284-3.2-.01.008-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M27.85 15.208l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M27.673 11.344l-.011 4.056 3.953.012.01-4.056-3.952-.012zm.375.387l3.2.01-.008 3.284-3.201-.01.009-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M22.297 8.89l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M22.12 5.027l-.012 4.055 3.953.012.011-4.056-3.953-.011zm.374.386l3.201.01-.009 3.284-3.2-.01.008-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M27.85 8.906l.01-3.67 3.577.01-.01 3.67z"
        mask="url(#b)"
      />
      <path
        fill="#000"
        d="M27.673 5.043l-.011 4.056 3.953.011.01-4.056-3.952-.011zm.375.387l3.2.01-.008 3.283-3.201-.009.009-3.284z"
        mask="url(#b)"
      />
      <path
        fill="#FF5050"
        d="M17.17 7.364l.339.851c.2.505.59.906 1.08 1.115l.828.353a.139.139 0 0 1 0 .192l-.83.348A2.018 2.018 0 0 0 17.5 11.33l-.343.85a.13.13 0 0 1-.188 0l-.339-.853c-.2-.504-.59-.905-1.08-1.114l-.828-.353a.139.139 0 0 1 0-.192l.83-.348a2.018 2.018 0 0 0 1.087-1.108l.344-.85a.13.13 0 0 1 .187 0M33.762.075l.232.584c.138.347.405.622.742.765l.568.243a.095.095 0 0 1 0 .131l-.57.24a1.384 1.384 0 0 0-.746.76l-.236.583a.09.09 0 0 1-.128 0l-.233-.585a1.386 1.386 0 0 0-.741-.765l-.569-.242a.095.095 0 0 1 0-.132l.57-.239c.338-.141.606-.415.746-.76l.236-.583a.09.09 0 0 1 .129 0M37.703 4.668l.187.47c.11.279.326.5.597.616l.457.195a.077.077 0 0 1 0 .106l-.459.192a1.115 1.115 0 0 0-.6.613l-.19.469a.072.072 0 0 1-.104 0l-.187-.47a1.116 1.116 0 0 0-.596-.617l-.458-.194a.077.077 0 0 1 0-.107l.459-.192c.271-.114.488-.334.6-.612l.19-.47a.072.072 0 0 1 .104 0"
        mask="url(#b)"
      />
      <path
        stroke="#000"
        strokeWidth=".616"
        d="M35.275 40.638H5.31"
        mask="url(#b)"
      />
    </g>
  </svg>
);

export default BuildingIcon;

BuildingIcon.propTypes = {
  className: PropTypes.string,
};
BuildingIcon.defaultProps = {
  className: "",
};
